import React, { useContext, useMemo } from 'react';

import { useAccounts } from '../../fetchHooks/useAccount';
import type { Account, AccountNumber } from '../../generated-types';
import { isValidAccountTransferFrom, isValidAccountTransferTo } from '../../services/accountFilters';

type TransferAccountStateType = { targetFromAccount: Account | undefined; targetToAccount: Account | undefined };
export const TransferAccountsState = React.createContext<TransferAccountStateType | undefined>(undefined);
export const useTransferAccountsContext = () => {
    const context = useContext(TransferAccountsState)! as TransferAccountStateType;
    if (context === undefined) {
        throw new Error('useTransferAccountsContext must be used within TransferAccountsState');
    }

    return context;
};

export const useTransferFromAndToAccount = (
    fromAccount: AccountNumber | undefined,
    toAccount: AccountNumber | undefined,
) => {
    const { data: accounts } = useAccounts();

    return useMemo(() => {
        const targetFromAccount = accounts
            ?.filter(isValidAccountTransferFrom)
            .find((account) => account.accountNumber.value === fromAccount?.value);
        const targetToAccount = accounts
            ?.filter(isValidAccountTransferTo)
            .find((account) => account.accountNumber.value === toAccount?.value);
        return { targetFromAccount, targetToAccount };
    }, [accounts, toAccount, fromAccount]);
};
